module.exports = __webpack_public_path__ + "static/media/logo_ins.2e9ff195.png";